import { ErrorMessage, Form, Formik } from 'formik';
import { Button, Header, Grid, Message, Icon } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import { UserShippingAddressFormValues } from '../../app/models/user';
import { stateOptions } from '../../app/common/options/stateOptions';
import { observer } from 'mobx-react-lite';
import { updateShippingValidationSchema } from '../../app/common/form/FormikFormValidations';
import MyTextInput from '../../app/common/form/MyTextInput';
import MySelectInput from '../../app/common/form/MySelectInput';
import MyZipCodeInput from '../../app/common/form/MyZipCodeInput';
import ValidationErrors from '../errors/ValidationErrors';

interface Props {
    isRedirect: boolean
}

export default observer(function ShippingForm({ 
    isRedirect
 }: Props) {
    const {userStore} = useStore();
    const { updateShipping, user } = userStore;
    
    return (
        <Formik
            initialValues={new UserShippingAddressFormValues(user!)}
            onSubmit={(values, {setErrors}) => updateShipping(values, isRedirect).catch(error => 
                setErrors({error}))}
            validationSchema={updateShippingValidationSchema}
        >
        {({handleSubmit, isSubmitting, errors, dirty, isValid}) => (
            <Form className='ui form error' onSubmit={handleSubmit} autoComplete='off'>
                <Grid>
                    <Grid.Row>
                        <Grid.Column>
                            <Header
                                as='h2'
                                content='Update WSF Account Shipping Address'
                                color='teal'
                            />
                            <Message icon>
                                <Icon name='shipping fast' />
                                <Message.Content>
                                    <Message.Header>{'WSF Account Shipping Address'}</Message.Header>
                                    {`Thank you for using WSF Buy On-line!  You are creating a WSF User Account, after your account is created you may use your email address and password to login and update your account information`}
                                </Message.Content>
                            </Message>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column computer={8} tablet={8} mobile={16}>
                            <label>First Name</label>
                            <MyTextInput name='shippingFirstName' placeholder='First Name' tabIndex={1} />
                            
                            <label>Address</label>
                            <MyTextInput name='shippingAddress' placeholder='Address' tabIndex={3} />
                        </Grid.Column>
                        <Grid.Column computer={8} tablet={8} mobile={16}>
                            <label>Last Name</label>
                            <MyTextInput name='shippingLastName' placeholder='Last Name' tabIndex={2} />

                            <label>Address 2</label>
                            <MyTextInput name='shippingAddress2' placeholder='Address 2' tabIndex={4} />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column computer={5} tablet={5} mobile={16}>
                            <label>City</label>
                            <MyTextInput name='shippingCity' placeholder='City' tabIndex={5} />
                        </Grid.Column>
                        <Grid.Column computer={5} tablet={5} mobile={16}>
                            <label>State</label>
                            <MySelectInput 
                                options={stateOptions} 
                                placeholder='--- Select State ---'  
                                name='shippingState' 
                                tabIndex={6} 
                            />
                        </Grid.Column>
                        <Grid.Column computer={5} tablet={5} mobile={16}>
                            <label>Zip Code</label>
                            <MyZipCodeInput name='shippingZipcode' placeholder='Zip Code' tabIndex={7} />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <ErrorMessage 
                            name='error' render={() => 
                            <ValidationErrors errors={errors.error}/>}
                        />
                        <Button 
                            disabled={!dirty || !isValid}
                            loading={isSubmitting} 
                            color='teal' 
                            content='Contiue'
                            type='submit'
                            fluid 
                        />
                    </Grid.Row>
                </Grid>
            </Form>
            )}
        </Formik>
    )
})